import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import auth from "../auth/auth";
import Login from "../auth/Login";
import Test from "../auth/Test_working";

const ProtectedRoutes = ({ component: Component, ...rest }) => {
  // const auths = auth.isAuthenticated()
  const auths = localStorage.getItem("auth");
  console.log("checking is logged in", auths);
  if (auths == "true") {
    console.log("yes do logged in");
    return <Outlet />;
  } else {
    console.log("not logged in");
    // return <Login />;
    return <Test />;
  }

  // return auths ? <Outlet/> : <Navigate to= '/login'/>
};

export default ProtectedRoutes;
